import { render, staticRenderFns } from "./OCR.vue?vue&type=template&id=04614f42&scoped=true&"
import script from "./OCR.vue?vue&type=script&lang=js&"
export * from "./OCR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04614f42",
  null
  
)

export default component.exports